<template>
  <div style="width: 100%;height: 100%;overflow: hidden">
    <el-image style="width: 100%;height: 100%" :src="pictureImg" fit="cover"></el-image>
  </div>
</template>
<script>

import {getImgApi} from "@/api/public";

export default {
  props: {
    fileId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      pictureImg:''
    };
  },
  created() {
    this.getImg()
  },
  mounted() {
    console.log(this.fileId)
  },
  watch:{
    fileId(newValue,oldValue){
      console.log(123)
      if (oldValue != newValue){
        this.getImg();
      }
    },
  },
  methods: {
    async getImg(){
      const res = await getImgApi(this.fileId)
      let blob = new Blob([res], {type: 'image/png'})
      let herf = window.URL.createObjectURL(blob)
      this.pictureImg = herf
    }
  }
}
</script>
